import { Program } from '@program/shared/program.model';
import { Organization } from '@shared/models/organization/organization.model';
import { User } from '@user/user.model';
import { PROGRAM_MESSAGE_TYPE } from './document-tag-type.enum';

export class ProgramMessageDocument {
  id: string;
  createUser: User;
  created: Date;
  updateUser: User;
  updated: Date;
  fileSize?: number;
  fileType?: string;
  filename?: string;
}

export class ProgramMessage {
  id?: string;
  program: Program;
  participantOrganization: Organization;
  message: string;
  sentDateTime: Date;
  sender: User;
  type?: PROGRAM_MESSAGE_TYPE;

  programMessageDocuments?: ProgramMessageDocument[];
  created?: Date;
  updated?: Date;
  updateUser?: User;
  createUser?: User;

  documentId?: string; // Transient
  isEvaluationMessage?: boolean;

  constructor(data: ProgramMessage) {
    this.id = data.id;
    this.sender = data.sender;
    this.type = data.type;
    this.createUser = data.createUser;
    this.created = data.created;
    this.updateUser = data.updateUser;
    this.updated = data.updated;
    this.program = data.program;
    this.message = data.message;
    this.sentDateTime = data.sentDateTime;
    this.programMessageDocuments = data.programMessageDocuments;
    this.participantOrganization = data.participantOrganization;
    this.documentId = data.documentId;
    this.isEvaluationMessage = data.isEvaluationMessage;
  }
}

export interface DisplayConfiguration {
  displayMessagesList: boolean;
  displayReceiverSender: boolean;
  displayStatusSelector?: boolean;
  isEvaluationMessage?: boolean;
}
